"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var shapes_base_1 = require("./shapes-base");

var utils_1 = require("./utils");

var config_1 = require("./config");

var lodash_1 = require("lodash");

var translations_1 = __importDefault(require("./translations"));

exports.createFrontShapes = function (plateComponents, canvas) {
  var shapes = [];
  var wallShapes = createWallShapes(plateComponents.elements.concat(plateComponents.additional), plateComponents.plate, canvas);
  shapes.push(wallShapes);
  var plateShapes = createPlateShapes(plateComponents.elements.concat(plateComponents.additional), plateComponents.plate, canvas);
  shapes.push(plateShapes);
  var elementShapes = createFrontElementShapes(plateComponents.elements.concat(plateComponents.additional), plateComponents.plate, canvas);
  shapes.push(elementShapes);
  return shapes;
};

var createWallShapes = function createWallShapes(elements, plate, canvas) {
  var shapes = []; // Left Wall

  var leftWallElement = elements.find(function (e) {
    return e.type === 'wall' && e.isFirst;
  });

  if (leftWallElement) {
    var x = plate.nsides.left;
    var y1 = canvas.scale.y;
    var y2 = 0;
    shapes.push(shapes_base_1.createVerticalWall(x, y1, x, y2, 'left'));
  } // Right wall


  var rightWallElement = elements.find(function (e) {
    return e.type === 'wall' && e.isLast;
  });

  if (rightWallElement) {
    var x = plate.nsides.right;
    var y1 = canvas.scale.y;
    var y2 = 0;
    shapes.push(shapes_base_1.createVerticalWall(x, y1, x, y2, 'right'));
  } // Floor


  if (leftWallElement || rightWallElement) {
    var x1 = plate.nsides.left - config_1.config.wall.thickness;
    var x2 = plate.nsides.right + config_1.config.wall.thickness;
    var y = canvas.scale.y;
    shapes.push(shapes_base_1.createLine(x1, y, x2, y, 4));
  }

  return shapes;
};

var createFrontElementShapes = function createFrontElementShapes(elements, plate, canvas) {
  var shapes = [];
  elements.forEach(function (element, index) {
    var nextElements = elements.slice(index + 1, elements.length) || []; // Center lines

    if (config_1.config.front.centerLines.includes(element.type)) {
      // Center line
      {
        var x = element.nposition.x;
        var y1 = canvas.scale.y - 20;
        var y2 = plate.nsides.bottom;
        shapes.push(shapes_base_1.createLine(x, y1, x, y2));
      } // Center line element - center line element

      var nextCenterElement = lodash_1.filter(nextElements, function (e) {
        return config_1.config.front.centerLines.includes(e.type);
      })[0];

      if (nextCenterElement) {
        var y = canvas.scale.y - 30;
        var x1 = element.nposition.x;
        var x2 = nextCenterElement.nposition.x;
        var dimension = nextCenterElement.position.x - element.position.x;
        var outerArrows = false;
        var arrowOffset = 'center';
        var textAlignment = 'middle';
        var textOffset = 'center';

        if (dimension < 100) {
          if (element.isFirst) {
            outerArrows = true;
            arrowOffset = 'left';
            textAlignment = 'end';
            textOffset = 'left';
          }

          if (element.isLast) {
            outerArrows = true;
            arrowOffset = 'right';
            textAlignment = 'start';
            textOffset = 'right';
          }
        }

        var nextNextCenterElement = lodash_1.filter(nextElements, function (e) {
          return config_1.config.front.centerLines.includes(e.type);
        })[1];

        if (!nextNextCenterElement) {
          dimension = Math.ceil(dimension);
          dimension = '(' + dimension + ')';
        }

        shapes.push(shapes_base_1.createMeasurementLine(x1, y, x2, y, false, outerArrows, arrowOffset));
        shapes.push(shapes_base_1.createText(utils_1.getCenter(x1, x2), y, dimension, false, textAlignment, textOffset));
      }
    } // Outline


    if (element.type === 'trough') {
      var x = element.nsides.left;
      var y = element.nposition.y;
      var width = element.nscale.x;
      var height = element.nscale.y;
      shapes.push(shapes_base_1.createImage(x, y, width, height, "https://kwcws3d.blob.core.windows.net/cdn/wireframes/" + element.fileName + "_front.svg", true));
    }

    if (element.type === 'surge-edge' || element.type === 'back-splash') {
      //  && element.nsides.left === plate.nsides.left
      // Shape
      {
        var x = element.nsides.left;
        var y = element.nsides.top;
        var width = element.nscale.x;
        var height = element.nscale.y;
        shapes.push(shapes_base_1.createRect(x - 1, y - 3, width + 1, height + 4));
      } // Text

      {
        var x = element.nposition.x;
        var y = element.nsides.top;
        var textLines = [];
        var hasSplashbackLeft = elements.find(function (e) {
          return (e.type === 'surge-edge' || e.type === 'back-splash') && e.isFirst;
        });
        var hasSplashbackRight = elements.find(function (e) {
          return (e.type === 'surge-edge' || e.type === 'back-splash') && e.isLast;
        });

        if (element.type === 'surge-edge') {
          textLines.push(translations_1.default.translate('Part.SurgeEdge'));
        } else {
          textLines.push(translations_1.default.translate('Part.Splashback'));
        }

        var position = '';

        if (hasSplashbackLeft) {
          position = position + translations_1.default.translate('Detail.Left') + ' + ';
        }

        position = position + translations_1.default.translate('Detail.Rear');

        if (hasSplashbackRight) {
          position = position + ' + ' + translations_1.default.translate('Detail.Right');
        }

        textLines.push(position);
        var explodedText = shapes_base_1.createExplodedText(x, y - 2, plate.nsides.left - config_1.config.explodedTextSpace, 12, textLines, 'left');
        shapes.push(explodedText);
      }
    } // Console


    if (element.type === 'console') {
      var x = element.nsides.left;
      var y = element.nposition.y;
      var width = element.nscale.x;
      var height = element.nscale.y;

      if (element.fileName === 'uhalter_miranit') {
        shapes.push(shapes_base_1.createImage(x, y, width, height, "https://kwcws3d.blob.core.windows.net/cdn/wireframes/" + element.fileName + "_front.svg", true));
      } else {
        shapes.push(shapes_base_1.createRect(x, y, width, height));
      }

      var nextConsole = lodash_1.filter(nextElements, function (e) {
        return e.type === 'console';
      })[0];
      var allConsoles = lodash_1.filter(elements, function (e) {
        return e.type === 'console';
      });
      var trough = lodash_1.filter(elements, function (e) {
        return e.type === 'trough';
      })[0];

      if (!nextConsole) {
        var textLines = [];

        if (element.fileName === 'uhalter_miranit') {
          textLines.push(allConsoles.length + 'x ' + translations_1.default.translate('Part.MiranitConsole'));

          if (trough.fileName === 'VARIUSmed_MZB') {
            textLines.push('2030024112');
          } else {
            textLines.push('2030024111');
          }
        } else if (element.materialName === 'stainlessSteel') {
          textLines.push(allConsoles.length + 'x ' + translations_1.default.translate('Part.StainlessSteelConsole'));

          if (element.scale.z === 370) {
            textLines.push('2030051321');
          } else {
            textLines.push('2030046394');
          }
        } else if (element.materialName === 'stainlessSteelWhite') {
          textLines.push(allConsoles.length + 'x ' + translations_1.default.translate('Edelstahl weiß-Konsole'));

          if (element.scale.z === 370) {
            textLines.push('2030051360');
          } else {
            textLines.push('2030050886');
          }
        }

        shapes.push(shapes_base_1.createExplodedText(element.nposition.x, y + height, plate.nsides.right + config_1.config.explodedTextSpace, plate.nsides.bottom + 65, textLines));
      } // Fastening


      if (element.elements) {
        var hasSameXPosition = element.elements.every(function (e) {
          return e.position.x === element.elements[0].position.x;
        });

        if (!hasSameXPosition) {
          // Vertical lines
          {
            var y_1 = plate.nsides.top - utils_1.calculateStep(1, true) - 20;
            shapes.push(shapes_base_1.createLine(element.elements[0].nposition.x, element.elements[0].nposition.y, element.elements[0].nposition.x, y_1));
            shapes.push(shapes_base_1.createLine(element.elements[1].nposition.x, element.elements[1].nposition.y, element.elements[1].nposition.x, y_1));
          } // Vertical measurement

          {
            var y_2 = plate.nsides.top - utils_1.calculateStep(1) - 20;
            var x1 = element.elements[0].nposition.x;
            var x2 = element.elements[1].nposition.x;
            var text = element.elements[1].position.x - element.elements[0].position.x;
            shapes.push(shapes_base_1.createMeasurementLine(x1, y_2, x2, y_2));
            shapes.push(shapes_base_1.createText(utils_1.getCenter(x1, x2), y_2, text));
          }
        }
      }
    } // Angle-bar


    if (element.type === 'angle-bar') {
      var x1 = element.nposition.x;
      var y1 = element.nposition.y;
      var y2 = y1 + element.nscale.y;
      var strokeWidth = config_1.config.shapes.strokeWidth;
      var nextAnglebar = lodash_1.filter(nextElements, function (e) {
        return e.type === 'angle-bar';
      })[0];

      if (!nextAnglebar) {
        if (element.isFirst) {
          var x2 = x1 + element.nscale.x;
          shapes.push(shapes_base_1.createLine(x1, y1 + strokeWidth, x2, y1 + strokeWidth, strokeWidth));
          shapes.push(shapes_base_1.createLine(x1 + strokeWidth, y2, x1 + strokeWidth, y1, strokeWidth));
        }

        if (element.isLast) {
          var x2 = x1 - element.nscale.x;
          shapes.push(shapes_base_1.createLine(x1, y1 + strokeWidth, x2, y1 + strokeWidth, strokeWidth));
          shapes.push(shapes_base_1.createLine(x1 - strokeWidth, y2, x1 - strokeWidth, y1, strokeWidth));
        }
      }
    } // Cutout


    if (element.type === 'cut-out-hole') {
      var x = element.nsides.left;
      var y = element.nsides.top;
      var width = element.nscale.x;
      var height = element.nscale.y;
      shapes.push(shapes_base_1.createRect(x, y, width, height + config_1.config.shapes.strokeWidth, true));
    } // Towel rail


    if (element.type === 'towel-rail') {
      var x = element.nsides.left;
      var y = element.nsides.top;
      var width = element.nscale.x;
      var height = element.nscale.y;
      shapes.push(shapes_base_1.createImage(x, y, width, height, "https://kwcws3d.blob.core.windows.net/cdn/wireframes/" + element.fileName + ".svg", true));
    } // Towel rail


    if (element.type === 'tissue-dispenser-hole') {
      var x = element.nsides.left;
      var y = element.nsides.top;
      var width = element.nscale.x;
      var height = element.nscale.y;
      shapes.push(shapes_base_1.createImage(x, y, width, height, "https://kwcws3d.blob.core.windows.net/cdn/wireframes/" + element.fileName + ".svg", true));
    } // Safety catches


    if (element.type === 'safety-catch') {
      var x = element.nsides.left;
      var y = element.nposition.y;
      var width = element.nscale.x;
      var height = element.nscale.y;
      shapes.push(shapes_base_1.createRect(x, y, width, height));
    } // Gel coat


    if (element.type === 'gelcoat') {
      var x = element.nposition.x + (element.nsides.right - element.nposition.x) / 1.2;
      var y = element.nposition.y;
      var textLines = [translations_1.default.translate('Part.UndersideCoated'), translations_1.default.translate('Part.WithGelcoat')];
      var explodedText = shapes_base_1.createExplodedText(x, y, plate.nsides.right + config_1.config.explodedTextSpace, plate.nsides.bottom + 20, textLines);
      shapes.push(explodedText);
    } // Sticker


    if (element.type === 'sticker') {
      // Outline
      {
        var x = element.nsides.left;
        var y = element.nsides.top;
        var height = element.nscale.y;
        var width = element.nscale.x;
        var textLines = [translations_1.default.translate('Part.Sticker'), '01812835'];
        shapes.push(shapes_base_1.createRect(x, y, width, height, false, 'black'));
        shapes.push(shapes_base_1.createExplodedText(element.nposition.x, y, plate.nsides.left - config_1.config.explodedTextSpace, plate.nsides.bottom + 40, textLines, 'left'));
      } // Vertical left/right lines

      {
        var y1 = element.nsides.top;
        var y2 = plate.nsides.top - utils_1.calculateStep(1, true);
        shapes.push(shapes_base_1.createLine(element.nsides.left, y1, element.nsides.left, y2));
        shapes.push(shapes_base_1.createLine(plate.nsides.left, y1, plate.nsides.left, y2));
      } // Horizontal measurement line

      {
        var x1 = element.nsides.left;
        var x2 = plate.nsides.left;
        var y = plate.nsides.top - utils_1.calculateStep(1);
        shapes.push(shapes_base_1.createMeasurementLine(x1, y, x2, y, false, true, 'right'));
        shapes.push(shapes_base_1.createText(x1, y, element.sides.left, false, 'start', 'right'));
      } // Plate line

      {
        var y = plate.nsides.top;
        var x1 = element.nposition.x;
        var x2 = plate.nsides.left - 85;
        shapes.push(shapes_base_1.createLine(x1, y, x2, y));
      } // Horizontal center line

      {
        var y = element.nposition.y;
        var x1 = element.nposition.x;
        var x2 = plate.nsides.left - 85;
        shapes.push(shapes_base_1.createLine(x1, y, x2, y));
      } // Vertical measurement line

      {
        var x = plate.nsides.left - 70;
        var y1 = element.nposition.y;
        var y2 = plate.nsides.top;
        shapes.push(shapes_base_1.createMeasurementLine(x, y1, x, y2, true, true, 'right'));
        shapes.push(shapes_base_1.createText(x, y2, element.position.y - plate.sides.top + '&nbsp;', true, 'start', 'right'));
      }
    }

    if (typeof element.elements !== 'undefined') {
      shapes.push(createFrontElementShapes(element.elements, plate, canvas));
    }
  });
  return shapes;
};

var createPlateShapes = function createPlateShapes(elements, plate, canvas) {
  var shapes = [];
  var frontApron = elements.find(function (e) {
    return e.type === 'apron' && !e.isLast && !e.isFirst;
  });

  if (frontApron) {
    var leftGap = 0;
    var rightGap = 0;
    var leftApron = elements.find(function (e) {
      return e.type === 'apron' && e.isFirst;
    });
    var rightApron = elements.find(function (e) {
      return e.type === 'apron' && e.isLast;
    });

    if (leftApron) {
      leftGap = leftApron.nscale.x;
    }

    if (rightApron) {
      rightGap = rightApron.nscale.x;
    } // Xray outline


    {
      var x = frontApron.nsides.left + leftGap;
      var y = plate.nsides.bottom;
      var width = frontApron.nscale.x - leftGap - rightGap;
      var height = frontApron.nscale.y - plate.nscale.y;
      shapes.push(shapes_base_1.createRect(x, y, width, height, true));
    } // Front apron outline

    {
      var x = frontApron.nsides.left;
      var y = frontApron.nsides.top;
      var width = frontApron.nscale.x;
      var height = frontApron.nscale.y;
      shapes.push(shapes_base_1.createRect(x, y, width, height));
    } // Horizontal top/bottom lines

    if (plate.nscale.y > 0) {
      var x1 = 0;
      var x2 = frontApron.nsides.left;
      shapes.push(shapes_base_1.createLine(x1, frontApron.nsides.top, x2, frontApron.nsides.top)); // Above line

      shapes.push(shapes_base_1.createLine(x1, frontApron.nsides.bottom, x2, frontApron.nsides.bottom)); // Below line
    } // Vertical scale


    if (plate.nscale.x > 0) {
      var x = config_1.config.text.space;
      var y1 = frontApron.nsides.bottom;
      var y2 = frontApron.nsides.top;
      var scale = frontApron.scale.y;
      shapes.push(shapes_base_1.createMeasurementLine(x, y1, x, y2, true, scale < 200));
      shapes.push(shapes_base_1.createText(x, utils_1.getCenter(y1, y2), scale, true));
    }
  } else {
    // Just outline of the plate
    if (plate.nscale.x > 0) {
      var x = plate.nsides.left;
      var y = plate.nsides.top;
      var width = plate.nscale.x;
      var height = plate.nscale.y;
      shapes.push(shapes_base_1.createRect(x, y, width, height));
    }
  } // Horizontal top/bottom lines

  /*
  if (plate.nscale.y > 0) {
    const x1 = calculateStep(1);
    const x2 = plate.nsides.left;
       shapes.push(createLine(x1, plate.nsides.top, x2, plate.nsides.top)); // Above line
    shapes.push(createLine(x1, plate.nsides.bottom, x2, plate.nsides.bottom)); // Below line
  }
  // Vertical scale
  if (plate.nscale.x > 0) {
    const x = calculateStep(1) + config.text.space;
    const y1 = plate.nsides.bottom;
    const y2 = plate.nsides.top;
    const scale = plate.scale.y;
       shapes.push(createMeasurementLine(x, y1, x, y2, true, true, 'right'));
    shapes.push(createText(x, getCenter(y1, y2), scale, true, 'start', 'right'));
  }
  */


  return shapes;
};